import './Plan.css'

/** Shown until the first snapshot arrives, so the week never flashes empty. */
export function PlanSkeleton() {
  return (
    <div className="pstack" aria-busy="true" aria-label="Loading tasks">
      {[3, 2, 1].map((n, g) => (
        <section key={g} className="day">
          <div className="day__head">
            <span className="skel skel--head" />
          </div>
          <div className="plist">
            {Array.from({ length: n }).map((_, i) => (
              <div key={i} className="skel__row">
                <span className="skel skel--ring" />
                <span className="skel skel--line" style={{ width: `${55 + ((i * 17) % 30)}%` }} />
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
